import type {
  AnalyticsHistoryWindow,
  AnalyticsWindow,
  EcosystemMetric,
  MarketInterval,
  MarketLeaderboardMetric,
  MarketWindow,
  ProviderHistoryMetric,
  ProviderLeaderboardMetric,
  ProviderSummarySort,
  TrendingWindow,
} from "@/api/hip3";

export const hip3QueryKeys = {
  all: ["hip3"] as const,
  markets: () => [...hip3QueryKeys.all, "markets"] as const,
  trending: (window: TrendingWindow, limit: number) =>
    [...hip3QueryKeys.all, "trending", window, limit] as const,
  marketStats: (provider: string, marketId: string, window: MarketWindow) =>
    [...hip3QueryKeys.all, "stats", provider, marketId, window] as const,
  marketHistory: (
    provider: string,
    marketId: string,
    window: MarketWindow,
    interval: MarketInterval
  ) => [...hip3QueryKeys.all, "history", provider, marketId, window, interval] as const,
  ecosystemOverview: (window: AnalyticsWindow) =>
    [...hip3QueryKeys.all, "analytics", "ecosystem", "overview", window] as const,
  ecosystemHistory: (metric: EcosystemMetric, window: AnalyticsHistoryWindow, interval: MarketInterval) =>
    [...hip3QueryKeys.all, "analytics", "ecosystem", "history", metric, window, interval] as const,
  providerSummary: (window: AnalyticsWindow, sort: ProviderSummarySort) =>
    [...hip3QueryKeys.all, "analytics", "providers", "summary", window, sort] as const,
  providerHistory: (metric: ProviderHistoryMetric, window: AnalyticsHistoryWindow, interval: MarketInterval) =>
    [...hip3QueryKeys.all, "analytics", "providers", "history", metric, window, interval] as const,
  marketLeaderboard: (
    metric: MarketLeaderboardMetric,
    window: AnalyticsWindow,
    limit: number,
    provider?: string,
    category?: string
  ) =>
    [
      ...hip3QueryKeys.all,
      "analytics",
      "leaderboards",
      "markets",
      metric,
      window,
      limit,
      provider ?? "",
      category ?? "",
    ] as const,
  providerLeaderboard: (metric: ProviderLeaderboardMetric, window: AnalyticsWindow, limit: number) =>
    [...hip3QueryKeys.all, "analytics", "leaderboards", "providers", metric, window, limit] as const,
  highlights: (window: "24h" | "7d") =>
    [...hip3QueryKeys.all, "analytics", "highlights", window] as const,
};
